<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form"
                    :model="model"
                    :rules="validatorRules"
                    slot="detail">
        <a-row>

          <a-col :span="12">
            <a-form-model-item :label="language['gift_company']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="company">
              <a-input v-model.trim="model.company"
                       :placeholder="language['gift_company_input']"
                       :disabled="isDisabled"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :label="language['gift_company_desc']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="companyDesc">
              <a-input v-model.trim="model.companyDesc"
                       :placeholder="language['gift_company_desc_input']"
                       :disabled="model.flag==='detail'"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JEditor from '@/components/jeecg/JEditor'

export default {
  name: 'GiftVendorForm',
  components: {
    JEditor,
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  data() {
    const language = this.$store.getters.language
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 2 },
      },

      labelCol3: {
        xs: { span: 24 },
        sm: { span: 2 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 21 },
      },

      confirmLoading: false,
      validatorRules: {
        company: [{ required: true, message: language['gift_company_input'] }],
        companyDesc: [{ required: true, message: language['gift_company_desc_input'] }],
      },
      url: {
        add: '/gift/company/add',
        edit: '/gift/company/edit',
        queryById: '/gift/company/queryById',
      },
      isDisabled: false,
      JEitorPlugins: 'lists link table textcolor wordcount contextmenu fullscreen',
      uploadSource: 'gift',
      type: 'add'
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    language() {
      return this.$store.getters.language
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    add() {
      console.log('二級傳入');
      
      this.model = Object.assign({}, this.modelDefault)
      this.visible = true
      this.isDisabled = false
      this.type = 'add'
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
      this.isDisabled = true
      this.type = 'edit'
    },
    submitForm() {
      if(this.model.flag==='detail') {
        this.$emit('ok')
        return
      }
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (this.type === 'add') {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },

    //手机号校验
    validatePhone(rule, value, callback) {
      let that = this
      if (!value) {
        callback()
      } else {
        if (new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)) {
          callback()
        } else {
          callback('請輸入正確格式的手機號碼')
        }
      }
    },
  },
}
</script>
